module.exports = __webpack_public_path__ + "static/media/girl-mekup-3.d5f375ae.png";